import React from "react";
import Camera from "../common/Camera";
import clsx from "clsx";
import ImageViewer from "../common/ImageViewer";
import moment from "moment";
import SignaturePad from "react-signature-canvas";
import SofIcon from "../common/Icons";
import { ActivityLog } from "../../models";
import { AuthProvider } from "../../AuthProvider";
import { Callout, DefaultButton, FontIcon } from "@fluentui/react";
import { Checkbox } from "@fluentui/react";
import { DatePicker } from "@fluentui/react";
import { Icon } from "@fluentui/react";
import { FC } from "react";
import { Fragment } from "react";
import { GeneralService } from "../../services/GeneralService";
import { groupBy } from "../../services/Helper";
import { MaskedTextField } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { MutableRefObject } from "react";
import { Nomination } from "../../models";
import { PrimaryButton } from "@fluentui/react";
import { RenderRow } from "./WorkPacketFormPage";
import { Text } from "@fluentui/react";
import { TextField } from "@fluentui/react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { WorkPacketFormItem } from "../../models/WorkPacket";
import { WorkPacketValue } from "../../models/WorkPacket";

type IProps = {
  disabled: boolean;
  documentId?: number;
  nominationNo?: string;
  values: WorkPacketValue[];
  item: WorkPacketFormItem;
  generalService?: GeneralService;
  onChange?: (event: any) => void;
};
const classes = mergeStyleSets({
  inputBox: {
    border: "1px solid #D8DFE6",
  },
  label: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 20,
    display: "flex",
    alignItems: "center",
    letterSpacing: "0.005em",
    color: "#4C4C4C",
  },
  labelTitle: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 20,
    display: "flex",
    alignItems: "center",
    letterSpacing: "0.005em",
    color: "#4C4C4C",
  },
  dateTimeContainer: { display: "flex", alignItems: "flex-end", gap: 12 },
  signCanvasContainer: {
    border: "1px solid #D8DFE6",
    background: "#fafafa",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    userSelect: "none",
  },
  photoButton: {
    border: "1px solid #D8DFE6",
    borderRadius: "2px",
    fontSize: "14px",
  },
  signClearButton: {
    border: "1px solid #D8DFE6",
    borderRadius: "2px",
    position: "absolute",
    right: 5,
    top: 5,
    fontSize: "11px",
  },
  signCanvas: {
    display: "flex",
    maxWidth: 300,
    width: "100%",
    height: "100%",
    margin: "auto",
    background: "#fff",
    position: "absolute",
  },
  imgSign: {
    maxWidth: "100%",
    height: "100%",
    objectFit: "scale-down",
    margin: "auto",
    background: "#fff",
  },
  callout: {
    width: 320,
    maxWidth: "90%",
    padding: "20px 24px",
  },
  iconContainer: {
    height: 32,
    display: "flex",
    alignItems: "center",
  },
  iconStyle: {
    color: "rgb(168, 0, 0)",
  },
  nominationGroup: {
    selectors: {
      ["> div:nth-child(odd)"]: {
        padding: 8,
        backgroundColor: "#f2f4f6",
      },
      ["> div:nth-child(even)"]: {
        padding: 8,
      },
    },
  },
  activityTable: {
    width: "100%",
    border: "solid 1px #e2e6e8",
    borderWidth: "0 0 1px 1px",
    selectors: {
      ["td"]: {
        border: "solid 1px #e2e6e8",
        borderWidth: "1px 1px 0 0",
      },
    },
  },
  signNavButton: {
    border: "none",
    userSelect: "none",
    position: "absolute",
    bottom: 0,
  },
  dataTableHeader: {
    fontSize: 14,
    fontWeight: 600,
    color: "rbg(50,49,48)",
  },
  dataTable: {
    marginBottom: 8,
    selectors: {
      ["> div:nth-child(even)"]: {
        background: "rgb(242, 244, 246)",
      },
    },
  },
  collapsiblePanelHeader: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    textTransform: "uppercase",
    userSelect: "none",
    selectors: {
      [":active"]: {
        background: "rgb(0, 140, 192)",
      },
    },
  },
});
const textInputStyles = {
  //root: classes.label,
  fieldGroup: classes.inputBox,
};
const datePickerStyles = {
  textField: {
    border: "transparent",
    selectors: {
      ["& .ms-TextField-fieldGroup"]: {
        border: "1px solid #D8DFE6",
      },
    },
  },
};
const WorkPacketFormItemComponent: FC<IProps> = (props: IProps) => {
  const { item } = props;

  return (
    <Fragment>
      {item.itemType === 0 && (
        <div
          dangerouslySetInnerHTML={{ __html: item.htmlContent }}
          style={{ fontSize: 14 }}
        />
      )}
      {item.itemType === 1 && <TextComponent {...props} />}
      {item.itemType === 2 && <DateComponent {...props} />}
      {item.itemType === 3 && <DateTimeComponent {...props} />}
      {item.itemType === 5 && <CheckboxComponent {...props} />}
      {item.itemType === 6 && <SignatureComponent {...props} />}
      {item.itemType === 7 && <SignatureListComponent {...props} />}
      {item.itemType === 8 && <TextAreaComponent {...props} />}
      {item.itemType === 9 && <NominationGroupComponent {...props} />}
      {item.itemType === 10 && <ActivityListComponent {...props} />}
      {item.itemType === 11 && <CameraComponent {...props} />}
      {item.itemType === 12 && <MultipleSignatureComponent {...props} />}
      {item.itemType === 13 && <DataTableComponent {...props} />}
      {item.itemType === 14 && <CollapsiblePanel {...props} />}
    </Fragment>
  );
};
export default WorkPacketFormItemComponent;

const autoComputes = (
  autoComputes: any,
  nominationNo?: string,
  values: WorkPacketValue[] | undefined = undefined,
  success: ((field: string, result: string) => void) | undefined = undefined
) => {
  const form = document.getElementById("dwp-form") as
    | HTMLFormElement
    | undefined;
  if (form === undefined) return;
  const formElements = form.elements as typeof form.elements & {
    usernameInput: { value: string };
  };
  const filtered = Array.from(formElements)
    .filter((f: any) => f.name && f.name.indexOf("--group-") < 0)
    .map((f: any) => ({
      name: f.name,
      value: f.value,
      nominationNo: f.title.length > 0 ? f.title : undefined,
    }));

  for (const autoCompute of autoComputes) {
    let val = "";
    let formula = autoCompute.formula;
    const fields = document.getElementsByName(autoCompute.field);
    if (fields.length === 1 && formula) {
      let field = fields.item(0) as HTMLInputElement;
      if (field === null) continue;
      if (values !== undefined) {
        const matches = formula.match(/\[(.*?)\]/g);
        if (matches)
          for (const match of matches) {
            const val = values.find(
              (f) =>
                f.fieldName === match.replace("[", "").replace("]", "") &&
                (nominationNo || f.nominationNo === nominationNo)
            );
            formula = formula.replace(match, val?.fieldValue ?? "");
          }
      } else {
        for (const f of filtered) {
          formula = formula.replace(`[${f.name}]`, f.value);
        }
      }
      try {
        val = eval(formula);
        field.value = val;
        field.setAttribute("aria-valuetext", val);
        if (success !== undefined) {
          success(autoCompute.field, val);
        }
      } catch {}
    }
  }
};

const TempConverter = (convertType: string, value: string) => {
  let result = "";
  if (convertType === "FahrenheitToCelsius") {
    result = value ? (((parseFloat(value) - 32) * 5) / 9).toFixed(2) : "";
  } else if (convertType === "CelsiusToFahrenheit") {
    result = value ? ((parseFloat(value) * 9) / 5 + 32).toFixed(2) : "";
  }

  return result;
};

const convertValue = (converts: any) => {
  const form = document.getElementById("dwp-form") as
    | HTMLFormElement
    | undefined;
  if (form === undefined) return;
  const formElements = form.elements as typeof form.elements & {
    usernameInput: { value: string };
  };
  const filtered = Array.from(formElements)
    .filter((f: any) => f.name && f.name.indexOf("--group-") < 0)
    .map((f: any) => ({
      name: f.name,
      value: f.value,
      nominationNo: f.title.length > 0 ? f.title : undefined,
    }));

  for (const convert of converts) {
    let val = "";
    let formula = convert.convertType;
    const fields = document.getElementsByName(convert.field1);
    const fields2 = document.getElementsByName(convert.field2);

    if (fields.length === 1 && fields2.length === 1 && formula) {
      let field = fields.item(0) as HTMLInputElement;
      let field2 = fields2.item(0) as HTMLInputElement;
      if (field === null && field2 === null) continue;
      for (const f of filtered) {
        if (f.name === field.name) {
          val = TempConverter(formula, f.value);
        }
      }
      field2.value = val;
      field2.setAttribute("aria-valuetext", val);
    }
  }
};

/* 1 = FREE TEXT
 * Simple input control
 */
const TextComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [textValue, setTextValue] = useState<string>();

  const onFocus = (e: any) => {
    const val = e.currentTarget.ariaValueText;
    if (val) {
      setTextValue(val);
    }
  };

  useEffect(() => {
    if (item.fieldName === "__doc_name__") {
      const htmlElement = document.getElementById("form-title");
      if (htmlElement) {
        let text = textValue;
        if (text === undefined || text.length === 0) {
          text = "<Other Service>";
        }
        htmlElement.innerText = text;
      }
    }

    if (item.otherProperties && item.otherProperties.autoComputes) {
      autoComputes(item.otherProperties.autoComputes, props.nominationNo);
    }
    if (item.otherProperties && item.otherProperties.convert) {
      convertValue(item.otherProperties.convert);
    }
  }, [textValue]);

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      setTextValue(val.fieldValue);
    } else {
      if (props.generalService && item.otherProperties) {
        props.nominationNo &&
          props.generalService.setActiveNomination(props.nominationNo);
        const _val = props.generalService.getFieldValue(
          item.otherProperties.defaultValue
        );
        setTextValue(_val);
      }
    }

    if (item.otherProperties && item.otherProperties.autoComputes) {
      autoComputes(
        item.otherProperties.autoComputes,
        props.nominationNo,
        values,
        (field, result) => {
          if (item.fieldName === field && result) {
            setTextValue(result);
          }
        }
      );
    }
  }, [values]);

  return (
    <TextField
      name={item.fieldName}
      label={item.label}
      placeholder={item.placeholder}
      data-validation={JSON.stringify(item.otherProperties?.validations)}
      styles={textInputStyles}
      disabled={disabled}
      maxLength={item.otherProperties?.maxLength}
      readOnly={item.otherProperties?.readonly}
      onChange={(e, newValue?: string) => {
        setTextValue(newValue);
        if (props.onChange) props.onChange(e);
      }}
      value={textValue}
      aria-label={props.nominationNo}
      title={props.nominationNo}
      description={item.otherProperties?.description}
      suffix={item.otherProperties?.suffix}
      onFocus={onFocus}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          e.currentTarget.blur();
        }
      }}
    />
  );
};

/* 2 = DATE ONLY
 * Use DatePicker and hidden input to store formatted value
 */
const DateComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [dateValue, setDateValue] = useState<Date>();
  const [dateTimeValue, setDateTimeValue] = useState<string>();

  const onSelectDate = (date: Date | null | undefined) => {
    if (date) {
      setDateValue(date);
      setDateTimeValue(date.toISOString());
    }
  };

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      var datevalue = moment(new Date(val.fieldValue));
      setDateValue(datevalue.toDate());
      setDateTimeValue(val.fieldValue);
    }
  }, [values]);

  return (
    <>
      <input
        name={item.fieldName}
        type="hidden"
        value={dateTimeValue ?? ""}
        title={props.nominationNo}
      />
      <DatePicker
        id={item.fieldName}
        label={item.label}
        formatDate={(val?: Date) => (val ? moment(val).format("ll") : "")}
        placeholder={item.placeholder}
        style={{ flexGrow: 1 }}
        styles={datePickerStyles}
        disabled={disabled}
        onSelectDate={onSelectDate}
        value={dateValue}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            e.currentTarget.blur();
          }
        }}
      />
    </>
  );
};

/* 3 = DATE AND TIME
 * Use DatePicker, MaskedTextField, and hidden input to store formatted value
 */
const DateTimeComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [dateValue, setDateValue] = useState<Date>();
  const [timeValue, setTimeValue] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [dateTimeValue, setDateTimeValue] = useState<string>();
  const [showErrorCallout, setShowErrorCallout] = useState(false);

  const onSelectDate = (date: Date | null | undefined) => {
    if (date !== null) {
      setDateValue(date);
    }
    if (date) {
      const vals = timeValue ? timeValue.split(":") : "00:00";
      date.setHours(parseInt(vals[0], 10));
      date.setMinutes(parseInt(vals[1], 10));

      //if (validate(date.toISOString())) {
      setDateTimeValue(date.toISOString());
      //}

      if (props.onChange) props.onChange(undefined);
    }
  };

  const onEditTime = (_e: any, value?: string) => {
    setTimeValue(value);
    if (value && dateValue) {
      value = value.replace("_", "");
      if (value.length !== 5) return;
      let date = new Date(dateValue);
      const vals = value.split(":");
      date.setHours(parseInt(vals[0], 10));
      date.setMinutes(parseInt(vals[1], 10));

      //if (validate(date.toISOString())) {
      setDateTimeValue(date.toISOString());
      //}

      if (props.onChange) props.onChange(undefined);
    }
  };

  const validate = (value: string) => {
    let valid = true;
    setErrorMessage(undefined);
    if (item.otherProperties && item.otherProperties.validations) {
      for (const validation of item.otherProperties.validations) {
        if (
          !props.generalService?.checkConditionsWithValue(
            validation.conditions,
            `new Date('${value}')`
          )
        ) {
          //setErrorMessage(validation.message);
          //setShowErrorCallout(true);
          valid = false;
          break;
        }
      }
    }
    return valid;
  };

  useEffect(() => {
    if (props.generalService && dateTimeValue) {
      props.generalService.updateWPValues({
        fieldName: item.fieldName,
        fieldValue: dateTimeValue,
        valueType: item.valueType,
      } as WorkPacketValue);
    }
  }, [dateTimeValue]);

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      var datevalue = moment(new Date(val.fieldValue));
      setDateValue(datevalue.toDate());
      setTimeValue(datevalue.format("HH:mm"));
      setDateTimeValue(val.fieldValue);
    }
  }, [values]);

  return (
    <div className={classes.dateTimeContainer}>
      <input
        name={item.fieldName}
        type="hidden"
        value={dateTimeValue ?? ""}
        title={props.nominationNo}
      />
      <div style={{ flex: 1 }}>
        <DatePicker
          label={item.label}
          formatDate={(val?: Date) => (val ? moment(val).format("ll") : "")}
          placeholder={item.placeholder}
          styles={datePickerStyles}
          disabled={disabled}
          onSelectDate={onSelectDate}
          value={dateValue}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              e.currentTarget.blur();
            }
          }}
        />
      </div>
      <div style={{ flex: 1,top: "-5px",position:"relative" }}>
        <MaskedTextField
          mask="12:32"
          maskFormat={{
            "1": /[0-2]/,
            "2": /[0-9]/,
            "3": /[0-5]/,
          }}
          style={{ flex: 1 }}
          styles={textInputStyles}
          disabled={disabled}
          iconProps={{ iconName: "Clock" }}
          onChange={onEditTime}
          value={timeValue}
        />
      </div>
      {errorMessage && (
        <div className={classes.iconContainer}>
          <Icon
            id={`dw-field-error-${item.id}`}
            iconName="StatusErrorFull"
            className={classes.iconStyle}
          />
          {showErrorCallout && (
            <Callout
              className={classes.callout}
              ariaLabelledBy={`dw-field-error-title-${item.id}`}
              ariaDescribedBy={`dw-field-error-desc-${item.id}`}
              role="dialog"
              gapSpace={0}
              target={`#dw-field-error-${item.id}`}
              onDismiss={() => setShowErrorCallout(false)}
              setInitialFocus
            >
              <Text
                as="h1"
                block
                variant="xLarge"
                //className={styles.title}
                id={`dw-field-error-title-${item.id}`}
              ></Text>
              <Text block variant="small" id={`dw-field-error-desc-${item.id}`}>
                {errorMessage}
              </Text>
            </Callout>
          )}
        </div>
      )}
    </div>
  );
};

/* 5 = Checkbox
 * Simple Checkbox control
 */
const CheckboxComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [isChecked, setIsChecked] = useState<boolean>();

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    setIsChecked(val && val.fieldValue === "true");
  }, [values]);

  return (
    <>
      <input
        name={item.fieldName}
        type="hidden"
        value={isChecked ? "true" : "false"}
        title={props.nominationNo}
      />
      <Checkbox
        name={
          item.otherProperties && item.otherProperties.group
            ? `--group-${item.otherProperties.group}`
            : undefined
        }
        label={item.label}
        styles={{
          checkbox: textInputStyles,
        }}
        onChange={(ev, checked) => {
          if (item.otherProperties?.group && checked) {
            const elements = document.getElementsByName(
              `--group-${item.otherProperties.group}`
            );
            Array.from(elements).forEach((element: HTMLElement) => {
              const inputElement = element as HTMLInputElement;
              if (inputElement.checked) {
                inputElement.click();
              }
            });
          }
          setIsChecked(checked);
          if (props.onChange) props.onChange(ev);
        }}
        checked={isChecked}
        disabled={disabled || item.otherProperties?.readonly === true}
      />
    </>
  );
};

/* 6 = SIGNATURE
 * Use SignaturePad, and hidden input to store string value
 */
const SignatureComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [signatureData, setSignatureData] = useState<string>();
  const signCanvas = useRef() as MutableRefObject<any>;
  const [wpValue, setWPValue] = useState<WorkPacketValue>();

  const onDrawEnd = () => {
    var signData = signCanvas.current.getTrimmedCanvas().toDataURL("");
    setSignatureData(signData);
  };

  const onClear = () => {
    setSignatureData(undefined);
    if (signCanvas.current) {
      signCanvas.current.clear();
    }
    if (wpValue) {
      setWPValue(undefined);
    }
    if (disabled) {
      signCanvas.current?.off();
    }
  };

  useEffect(() => {
    if (disabled) {
      signCanvas.current?.off();
    } else {
      signCanvas.current?.on();
    }
  }, [disabled]);

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      setWPValue(val);
      setSignatureData(val.fieldValue);
    }

    if (disabled && signCanvas.current) {
      signCanvas.current?.off();
    }
  }, [values]);

  return (
    <>
      <input
        name={item.fieldName}
        value={signatureData}
        type="hidden"
        title={props.nominationNo}
      />
      <label className={classes.label}>{item.label}</label>
      <div
        className={classes.signCanvasContainer}
        style={{ height: item.colSpan > 3 ? 120 : 90 }}
      >
        {signatureData && !disabled && (
          //<DefaultButton onClick={onClear} text="Clear" />
          <button
            onClick={onClear}
            className={classes.signClearButton}
            style={{ zIndex: 1 }}
          >
            Clear
          </button>
        )}
        {wpValue === undefined && (
          <SignaturePad
            ref={signCanvas}
            canvasProps={{
              className: classes.signCanvas,
            }}
            clearOnResize={false}
            penColor="black"
            onEnd={onDrawEnd}
          />
        )}
        {wpValue && (
          <div className={classes.signCanvas}>
            <img className={classes.imgSign} src={wpValue.fieldValue} />
          </div>
        )}
      </div>
    </>
  );
};

/* 7 = SIGNATURE LIST
 * Use SignaturePad, and hidden input to store string value
 */
const SignatureListComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [signatureData, setSignatureData] = useState<string>();
  const signCanvas = useRef() as MutableRefObject<any>;
  const [wpValue, setWPValue] = useState<WorkPacketValue>();
  const accountInfo = AuthProvider.getAccountInfo();
  const onDrawEnd = () => {
    var signData = signCanvas.current.getTrimmedCanvas().toDataURL("");
    setSignatureData(signData);
  };

  const onClear = () => {
    setSignatureData(undefined);
    if (signCanvas.current) {
      signCanvas.current.clear();
    }
    if (wpValue) {
      setWPValue(undefined);
    }
    if (disabled) {
      signCanvas.current?.off();
    }
  };

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.createdBy.toLowerCase() ===
          accountInfo?.account.accountIdentifier.toLocaleLowerCase() &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      setWPValue(val);
      setSignatureData(val.fieldValue);
    }
    if (disabled) {
      signCanvas.current?.off();
    }
  }, [values]);

  return (
    <>
      <input
        name={item.fieldName}
        value={signatureData}
        type="hidden"
        title={props.nominationNo}
      />
      <label className={classes.label}>{item.label}</label>
      <div
        className={classes.signCanvasContainer}
        style={{ height: item.colSpan > 3 ? 120 : 90 }}
      >
        {signatureData && (
          // <DefaultButton
          //   onClick={onClear}
          //   text="Clear"
          //   style={{ zIndex: 1, width: 10, height: 10 }}
          // />
          <button
            onClick={onClear}
            className={classes.signClearButton}
            style={{ zIndex: 1 }}
          >
            Clear
          </button>
        )}
        {wpValue === undefined && (
          <SignaturePad
            ref={signCanvas}
            canvasProps={{
              className: classes.signCanvas,
            }}
            clearOnResize={false}
            penColor="black"
            onEnd={onDrawEnd}
          />
        )}
        {wpValue && (
          <div className={classes.signCanvas}>
            <img className={classes.imgSign} src={wpValue.fieldValue} />
          </div>
        )}
      </div>
    </>
  );
};

/* 8 = TEXT AREA
 * Group of forms within the form
 */
const TextAreaComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [textValue, setTextValue] = useState<string>();

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      setTextValue(val.fieldValue);
    } else {
      if (props.generalService && item.otherProperties) {
        props.nominationNo &&
          props.generalService.setActiveNomination(props.nominationNo);
        const _val = props.generalService.getFieldValue(
          item.otherProperties.defaultValue
        );
        setTextValue(_val);
      }
    }
  }, [values]);

  return (
    <TextField
      name={item.fieldName}
      label={item.label}
      placeholder={item.placeholder}
      styles={textInputStyles}
      disabled={disabled}
      maxLength={item.otherProperties?.maxLength}
      readOnly={item.otherProperties?.readonly}
      onChange={(e, newValue?: string) => setTextValue(newValue)}
      value={textValue}
      aria-label={props.nominationNo}
      title={props.nominationNo}
      multiline
      rows={3}
    />
  );
};

/* 9 = NOMINATION GROUP
 * Group of forms within the form
 */
const NominationGroupComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values } = props;
  const [nominations, setNominations] = useState<Nomination[]>();
  const [groupedRow, setGroupedRow] = useState<WorkPacketFormItem[][]>([]);

  useEffect(() => {
    setNominations(props.generalService?.nominations);
    if (item.items) {
      const grouped = groupBy(item.items, "row");
      setGroupedRow(Object.values(grouped));
    }
  }, [values]);

  return (
    <div className={classes.nominationGroup}>
      {nominations &&
        nominations.map((nom, ii: number) => (
          <div key={`nom-group-field-${nom.nominationNo}`}>
            <h5>
              {nom.nominationNo} - {nom.product}
            </h5>
            <hr />
            <div className="ms-Grid" dir="ltr">
              {groupedRow.map((items, i: number) => (
                <RenderRow
                  key={`form-row-${i}-${nom.nominationNo}`}
                  formField={items.map((f) => ({
                    ...f,
                    fieldName: f.fieldName + "#" + ii,
                  }))}
                  values={values}
                  disabled={disabled}
                  nominationNo={nom.nominationNo}
                  generalService={props.generalService}
                ></RenderRow>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
};

/* 10 = ACTIVITY LIST
 * Table list of specified activities within SOF
 */
const ActivityListComponent: FC<IProps> = (props: IProps) => {
  const { item, values } = props;
  const [activities, setActivities] = useState<ActivityLog[]>([]);
  const [value, setValue] = useState<string>();

  const formatDate = (logTime: string): string => {
    var date = moment.utc(logTime).format();
    var local = moment.utc(date).local().format();

    return moment(local).format("ll HH:mm");
  };

  useEffect(() => {
    //setActivities([]);
    //setValue('');

    if (item.otherProperties && item.otherProperties.actionIds) {
      const _actionIds = item.otherProperties.actionIds as number[];
      const _activities =
        _actionIds &&
        props.generalService?.activities.filter(
          (f) =>
            _actionIds.indexOf(f.processActionId ?? 0) >= 0 &&
            f.nominationNo === props.nominationNo
        );
      if (_activities) {
        var val = [];
        for (const _act of _activities) {
          val.push(
            `${_act.description.padEnd(40, " ")}${formatDate(
              _act.logTime
            ).padStart(20, " ")}\n`
          );
        }

        setValue(val.join(""));
        setActivities(_activities);
      }
    }
  }, [values]);

  return (
    <div>
      <input
        name={item.fieldName}
        value={value}
        type="hidden"
        title={props.nominationNo}
      />
      <label className={classes.label}>{item.label}</label>
      <div>
        <table className={classes.activityTable} cellPadding={8}>
          <tbody>
            {activities.map((a: ActivityLog) => (
              <tr key={a.id}>
                <td style={{ width: "50%" }}>{a.description}</td>
                <td align="right">{formatDate(a.logTime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* 11 = Camera
 * Uses Camera ibrary to take picture from devices camera
 */
const CameraComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, documentId, values } = props;
  let imageUploadRef: HTMLInputElement | null;
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState<string | null>(null);

  const onImageUpload = (e: any) => {
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    if (!["png", "jpeg", "jpg"].includes(extension)) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      setImgSrc(reader.result as string);
    };
  };

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      //setWPValue(val);
      setImgSrc(val.fieldValue);
    }
  }, [values]);

  return (
    <div>
      <label className={classes.labelTitle}>{item.label}</label>
      <input
        name={item.fieldName}
        value={imgSrc || ""}
        type="hidden"
        title={props.nominationNo}
      />
      <Camera
        isOpen={isCameraOpen}
        closeCamera={() => setIsCameraOpen(false)}
        takePhoto={(base64) => {
          setImgSrc(base64);
          setTimeout(() => setIsCameraOpen(false), 1000);
        }}
      />
      <div>
        {imgSrc ? (
          <div>
            <div
              onClick={() => setImgSrc(null)}
              style={{
                position: "absolute",
                right: 20,
                top: 40,
                paddingTop: 6,
                height: 40,
                width: 40,
                borderRadius: "50%",
                zIndex: 20,
                cursor: "pointer",
                background: "#fff",
                border: "1px solid #4c4c4c",
                textAlign: "center",
              }}
            >
              <span>
                <SofIcon iconname="DeleteItem" />
              </span>
            </div>
            <ImageViewer imgSrc={imgSrc} />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              columnGap: 5,
            }}
          >
            <PrimaryButton
              onClick={() => setIsCameraOpen(true)}
              text="Take Photo"
              disabled={disabled}
            />
            {/*<button*/}
            {/*  onClick={() => setIsCameraOpen(true)}*/}
            {/*  className={classes.photoButton}*/}
            {/*  disabled={disabled}*/}
            {/*>*/}
            {/*  Take Photo*/}
            {/*              </button>*/}
            <DefaultButton
              onClick={() => imageUploadRef?.click()}
              text="Upload Photo"
              disabled={disabled}
            />
            {/*<button*/}
            {/*  onClick={() => imageUploadRef?.click()}*/}
            {/*  className={classes.photoButton}*/}
            {/*  disabled={disabled}*/}
            {/*>*/}
            {/*  Upload Photo*/}
            {/*</button>*/}
            <input
              ref={(input) => (imageUploadRef = input)}
              accept="image/jpeg, image/png"
              onChange={(e) => onImageUpload(e)}
              style={{
                position: "absolute",
                width: 0,
                height: 0,
              }}
              type="file"
            />
          </div>
        )}
      </div>
    </div>
  );
};

/* 12 = Multiple Signature
 * User SignaturePad, and save multiple values delimited by \r\n
 */
const MultipleSignatureComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values, documentId } = props;
  const [signatureData, setSignatureData] = useState<string>();
  const [wpValue, setWPValue] = useState<WorkPacketValue>();
  const [binaryValues, setBinaryValues] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const signCanvas = useRef() as MutableRefObject<any>;
  const MAX_SIGNATURE = 5;

  const onDrawEnd = () => {
    var signData = signCanvas.current.getTrimmedCanvas().toDataURL("");
    if (wpValue) {
      setSignatureData(wpValue.fieldValue + "\r\n" + signData);
    } else {
      setSignatureData(signData);
    }
  };

  const onClear = () => {
    setSignatureData(undefined);
    if (signCanvas.current) {
      signCanvas.current.clear();
    }
    if (wpValue) {
      setSignatureData(wpValue.fieldValue);
    }
    if (disabled) {
      signCanvas.current?.off();
    }
  };

  const onPrev = () => {
    setCurrentIndex((index) => --index);
  };

  const onNext = () => {
    setCurrentIndex((index) => ++index);
  };

  useEffect(() => {
    if (disabled) {
      signCanvas.current?.off();
    } else {
      signCanvas.current?.on();
    }
  }, [disabled]);

  useEffect(() => {
    const val = values.find(
      (f) =>
        f.fieldName === item.fieldName &&
        f.nominationNo === props.nominationNo &&
        f.documentId === documentId
    );
    if (val && val.fieldValue) {
      const _val = val.fieldValue.split("\r\n");
      setWPValue(val);
      setBinaryValues(_val);
      setCurrentIndex(_val.length - 1);
      setSignatureData(val.fieldValue);
    } else {
      setCurrentIndex(0);
    }

    if (disabled) {
      signCanvas.current?.off();
    }
  }, [values]);

  return (
    <>
      <input
        name={item.fieldName}
        value={signatureData}
        type="hidden"
        title={props.nominationNo}
      />
      <label className={classes.label}>{item.label}</label>
      <div
        className={classes.signCanvasContainer}
        style={{ height: item.colSpan > 3 ? 120 : 90 }}
      >
        {currentIndex === binaryValues.length &&
          wpValue?.fieldValue !== signatureData &&
          !disabled && (
            //<DefaultButton onClick={onClear} text="Clear" />
            <button
              type="button"
              onClick={onClear}
              className={classes.signClearButton}
              style={{ zIndex: 1 }}
            >
              Clear
            </button>
          )}
        {currentIndex === binaryValues.length && (
          <SignaturePad
            ref={signCanvas}
            canvasProps={{
              className: classes.signCanvas,
            }}
            clearOnResize={false}
            penColor="black"
            onEnd={onDrawEnd}
          />
        )}
        {binaryValues[currentIndex] && (
          <div className={classes.signCanvas}>
            <img className={classes.imgSign} src={binaryValues[currentIndex]} />
          </div>
        )}
      </div>

      {binaryValues.length > 0 && currentIndex > 0 && (
        <button
          type="button"
          className={classes.signNavButton}
          onClick={onPrev}
          style={{ left: 8 }}
          title="Previous"
        >
          &lt;
        </button>
      )}
      {binaryValues.length > currentIndex &&
        currentIndex + 1 < MAX_SIGNATURE && (
          <button
            type="button"
            className={classes.signNavButton}
            onClick={onNext}
            style={{ right: 8 }}
            title={binaryValues.length === currentIndex + 1 ? "Add" : "Next"}
          >
            {binaryValues.length === currentIndex + 1 ? "+" : <>&gt;</>}
          </button>
        )}
    </>
  );
};

/* 13 = Data Table
 * Show data in grid view
 */
const DataTableComponent: FC<IProps> = (props: IProps) => {
  const { item, disabled, values } = props;
  const [data, setData] = useState<any[]>([]);
  const accountInfo = AuthProvider.getAccountInfo();
  const MAX_ROW = 18;

  const updateRow = (index: number) => {
    let array = [...data];
    const arrayItem = array[index];
    if (arrayItem && arrayItem.user !== accountInfo?.account.name) {
      array[index].user = accountInfo?.account.name;
      setData(array);
    }
  };

  const addRow = () => {
    setData((prev) => [...prev, { user: accountInfo?.account?.name }]);
  };

  useEffect(() => {
    const vals = values.filter((f) => f.fieldName.startsWith(item.fieldName));
    if (vals.length > 0) {
      setData(vals.map((v) => ({ user: v.fieldValue })));
    } else {
      setData([{ user: accountInfo?.account?.name }]);
    }
  }, [values]);

  return (
    <div>
      <div></div>
      <div className={clsx("ms-Grid", classes.dataTable)} dir="ltr">
        <div className="ms-Grid-row">
          {item.otherProperties?.columns?.map((col: any) => (
            <div className={`ms-Grid-col ms-sm12 ms-md${col.colSpan}`}>
              <label className={classes.dataTableHeader}>{col.label}</label>
            </div>
          ))}
        </div>
        {data.map((data, index) => (
          <div
            className="ms-Grid-row"
            style={{ display: "flex", alignItems: "center" }}
          >
            {item.otherProperties?.columns?.map((col: any) => (
              <div className={`ms-Grid-col ms-sm12 ms-md${col.colSpan}`}>
                <div>
                  {item.items
                    ?.filter((f) => f.otherProperties?.dataColumn === col.name)
                    .map((_item: WorkPacketFormItem) => (
                      <WorkPacketFormItemComponent
                        disabled={disabled}
                        item={{
                          ..._item,
                          fieldName: `${_item.fieldName}#${index}`,
                          otherProperties: {
                            ..._item.otherProperties,
                            group: _item.otherProperties?.group
                              ? `${_item.otherProperties?.group}${index}`
                              : undefined,
                          },
                        }}
                        documentId={props.documentId}
                        nominationNo={props.nominationNo}
                        values={props.values}
                        onChange={() => updateRow(index)}
                      />
                    ))}
                </div>
              </div>
            ))}
            <div className="ms-Grid-col ms-sm12 ms-md2">
              <FontIcon iconName="TemporaryUser" />
              &nbsp;
              <span style={{ fontSize: 14, fontWeight: 500 }}>{data.user}</span>
              <input
                name={`${item.fieldName}#${index}`}
                type="hidden"
                value={data.user}
                title={props.nominationNo}
              />
            </div>
          </div>
        ))}
      </div>
      <div style={{ textAlign: "end" }}>
        <PrimaryButton
          disabled={disabled || data.length === MAX_ROW}
          text="Add Row"
          iconProps={{ iconName: "Add" }}
          onClick={addRow}
        />
      </div>
    </div>
  );
};

/* 14 = Collapsible Panel
 * Similar to NominationGroup expect it doesn't go per nomination
 */
const CollapsiblePanel: FC<IProps> = (props: IProps) => {
  const { item, disabled, values } = props;
  const [shown, setShown] = useState(true);
  const [groupedRow, setGroupedRow] = useState<WorkPacketFormItem[][]>([]);

  useEffect(() => {
    if (item.items) {
      const grouped = groupBy(item.items, "row");
      setGroupedRow(Object.values(grouped));
    }
  }, [values]);

  return (
    <div>
      <div
        className={classes.collapsiblePanelHeader}
        onClick={() => setShown((prev) => !prev)}
      >
        <h6>{item.label}</h6>
        <Icon iconName={shown ? "ChevronUp" : "ChevronDown"} />
      </div>
      <div
        className="ms-Grid"
        dir="ltr"
        style={{ display: shown ? "block" : "none" }}
      >
        {groupedRow.map((items, i: number) => (
          <RenderRow
            key={`form-row-${i}`}
            formField={items}
            values={values}
            disabled={disabled}
            nominationNo={props.nominationNo}
            generalService={props.generalService}
          ></RenderRow>
        ))}
      </div>
      <hr />
    </div>
  );
};
